/*
	Generated on 12/02/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.5.14
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link, useParams } from "react-router";
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import FormUbahKurikulum from '../components/FormUbahKurikulum'

import getKurikulumData from '../services/getKurikulumData'
import getProgramStudi from '../services/getProgramStudi'

const UbahKurikulumPage = props => {

	const [isLoading, setIsLoading] = useState({
	ubahKurikulum: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [searchParams] = useSearchParams()
const id = searchParams.get('id')
const [kurikulumData, setKurikulumData] = useState()
const [programStudi, setProgramStudi] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, ubahKurikulum: true}))
		const { data: kurikulumDataResponse } = await getKurikulumData({ id  })
 		const { data: programStudiResponse } = await getProgramStudi({ })

	    setKurikulumData(kurikulumDataResponse.data)
  		setProgramStudi(programStudiResponse.data)


	    setIsLoading(prev => ({...prev, ubahKurikulum: false}))
    }
    fetch()
  }, [])

	
	useEffect(() => {
		setTitle("Ubah Kurikulum Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kurikulum/${id}
			  	`}>
			  		<Button className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
<Layouts.FormContainerLayout
		singularName={"Kurikulum"}
		isLoading={isLoading.ubahKurikulum}
	>
		{kurikulumData && programStudi ? 
		(<>
		 <FormUbahKurikulum
			{...{ 
				kurikulumData
,    			programStudi

				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

	</Layouts.ViewContainerLayout>
  )
}
export default UbahKurikulumPage

